import "./hometext.css";

function HomeText({ children, title = "", w }) {
  const separatorstyle =
    title === ""
      ? { display: "none" }
      : {
          height: "2px",
          backgroundColor: "#bb7000",
          width: "80%",
          marginTop: "10px",
          marginBottom: "10px",
        };
  return (
    <div className="home-text-contenair">
      <div className="home-text-title">{title}</div>
      <div className="home-text-seprator-contenair">
        <div className="home-text-separator" style={separatorstyle}></div>
      </div>
      <div className="home-text">{children}</div>
    </div>
  );
}

export default HomeText;
